$.fn.SearchPageField = function() {
  let self = this
  if (self.data('suggestions')) {
    self.form = self.parents('form')
    self.button = self.parent().find('.search-form__submit')
    self.animating = false
    self.suggestions = self.data('suggestions').split(',')
    self.currentWordIndex = 0
    self.currentLetterIndex = 0
    self.direction = 'forward'
    self.ticker = undefined

    self.stop = function() {
      clearTimeout(self.ticker)
      self.ticker = undefined
      self.animating = false
    }

    self.tick = function() {
      let delay = self.direction == 'forward' ? 50 : 25
      self.currentLetterIndex += self.direction == 'forward' ? 1 : -1
      if (self.currentLetterIndex == self.suggestions[self.currentWordIndex].length) {
        delay = 1000
      } else if (self.currentLetterIndex > self.suggestions[self.currentWordIndex].length && self.direction == 'forward') {
        self.direction = 'backward'
      } else if (self.currentLetterIndex == 0 && self.direction == 'backward') {
        self.currentWordIndex += 1
        self.direction = 'forward'
        delay = 275
      }
      if (self.currentWordIndex >= self.suggestions.length) {
        self.currentWordIndex = 1 // avoid "Je recherche..."
      }
      self.val(self.suggestions[self.currentWordIndex].substr(0, self.currentLetterIndex))
      self.ticker = setTimeout(self.tick, delay)
      self.animating = true
    }

    self.suggested_search = function(e) {
      if (self.animating) {
        e.preventDefault()
        if (self.currentWordIndex === 0) {
          return false // prevent submit on "Je recherche..."
        }
        self.stop()
        self.val(self.suggestions[self.currentWordIndex])
        self.form.submit()
      }
    }

    self.focused = function() {
      if (self.animating) {
        self.stop()
        self.val('')
      }
    }

    self.blurred = function() {
      if (self.val() == '') {
        self.currentWordIndex = 0
        self.currentLetterIndex = 0
        self.tick()
      }
    }

    return function() {
      self.on('focus', self.focused)
      self.on('blur', self.blurred)
      if (!self.val() || self.val() == self.attr('placeholder')) {
        self.val('')
        self.ticker = setTimeout(self.tick, 500)
      }
      self.suggestions.unshift('Je recherche...')
      self.attr('placeholder', '')
      self.button.on('click', self.suggested_search)
      return self
    }()
  }
}
